var map = {
	"./zdjęcie do slidera (2).webp": 1783,
	"./zdjęcie do slidera (3).webp": 9398,
	"./zdjęcie do slidera (4).webp": 993,
	"./zdjęcie do slidera.webp": 9466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1250;